import { useEffect, useState } from "react";
import { api } from "./api/client";
import { AdminPage } from "./pages/AdminPage";
import { LoginPage } from "./pages/LoginPage";
import { StudentPage } from "./pages/StudentPage";
import type { SessionUser } from "./types";

export default function App() {
  const [user, setUser] = useState<SessionUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .me()
      .then((response) => setUser(response.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  async function logout() {
    await api.logout();
    setUser(null);
  }

  if (loading) {
    return <div className="boot-screen">Carregando portal...</div>;
  }

  if (!user) return <LoginPage onLogin={setUser} />;

  if (user.perfil === "admin") return <AdminPage user={user} onLogout={logout} />;

  return <StudentPage user={user} onLogout={logout} />;
}
